port module Main exposing (..)

import Browser
import Html exposing (Html, div, h1, h2, img, text)
import Html.Attributes exposing (class)
import Html.Events exposing (onClick)
import Html.Keyed
import Json.Decode as Decode
import Json.Decode.Pipeline


port updateFromJsToElm : (Decode.Value -> msg) -> Sub msg


type alias Document msg =
    { title : String
    , body : List (Html msg)
    }


type alias Model =
    { updates : List Update
    , maxUpdates : Int
    , popup : PopupContent
    }


type PopupContent
    = NoContent
    | Content (Html Msg)
    | Hiding (Html Msg)


type alias Update =
    { id : Int
    , feedUrl : String
    , imageUrl : String
    , title : String
    , description : String
    , author : String
    , ownerName : String
    , language : String
    , country : String
    }


type Msg
    = NoOp
    | AddUpdate Update
    | ShowPopup PopupContent
    | HidePopup


main : Program () Model Msg
main =
    Browser.document
        { init = init
        , view = view
        , update = update
        , subscriptions = subscriptions
        }


init : () -> ( Model, Cmd Msg )
init _ =
    ( { updates = []

      -- List.range 0 24
      --     |> List.map (\_ -> { imgUrl = "https://cdn.podcloudmidia.com.br/podcast/e826f1c8-b0ff-48b3-83f6-cdbf88052caf/image/logo_20200407145439.jpg" })
      , maxUpdates = 49
      , popup = NoContent
      }
    , Cmd.none
    )


update : Msg -> Model -> ( Model, Cmd Msg )
update msg model =
    case msg of
        NoOp ->
            model |> noCmd

        AddUpdate update_ ->
            let
                newUpdate =
                    update_ :: model.updates

                limitedUpdate =
                    if List.length newUpdate > model.maxUpdates then
                        List.take 25 newUpdate

                    else
                        newUpdate
            in
            { model | updates = limitedUpdate } |> noCmd

        ShowPopup mContent ->
            { model | popup = mContent } |> noCmd

        HidePopup ->
            let
                popup =
                    case model.popup of
                        NoContent ->
                            NoContent

                        Hiding c ->
                            Hiding c

                        Content c ->
                            Hiding c
            in
            { model | popup = popup } |> noCmd


subscriptions : Model -> Sub Msg
subscriptions model =
    updateFromJsToElm decodeUpdates


decodeUpdates : Decode.Value -> Msg
decodeUpdates val =
    case Decode.decodeValue updateDecoder val of
        Ok upd ->
            AddUpdate upd

        Err err ->
            NoOp



{-
   const update = {
         feedUrl,
         imageUrl: podcast.feed?.artwork || podcast.feed?.image,
         title: podcast.title,
         description: podcast.description,
         author: podcast.author,
         ownerName: podcast.ownerName,
         language: podcast.language,
         country: podcast.language?.split("-")?.[1],
       };
-}


updateDecoder : Decode.Decoder Update
updateDecoder =
    Decode.succeed Update
        |> Json.Decode.Pipeline.required "id" Decode.int
        |> Json.Decode.Pipeline.required "feedUrl" Decode.string
        |> Json.Decode.Pipeline.required "imageUrl" Decode.string
        |> Json.Decode.Pipeline.required "title" Decode.string
        |> Json.Decode.Pipeline.required "description" Decode.string
        |> Json.Decode.Pipeline.required "author" Decode.string
        |> Json.Decode.Pipeline.required "ownerName" Decode.string
        |> Json.Decode.Pipeline.required "language" Decode.string
        |> Json.Decode.Pipeline.required "country" Decode.string


view : Model -> Browser.Document Msg
view model =
    { title = "Elm Hivehydra viewer"
    , body =
        [ case model.popup of
            Content content ->
                div [ Html.Attributes.class "popup" ] [ content ]

            NoContent ->
                text ""

            Hiding content ->
                div [ Html.Attributes.class "popup hiding" ] [ content ]
        , div [ Html.Attributes.class "square" ]
            (case model.updates of
                [] ->
                    [ h1 [ Html.Attributes.style "font-size" "30px" ] [ text "Waiting for PodPings" ], spinner ]

                _ ->
                    viewUpdates model.updates
            )
        , div [ Html.Attributes.style "margin" "auto" ] [ text <| "Received " ++ String.fromInt (List.length model.updates) ++ " updates so far." ]
        ]
    }


viewUpdates : List Update -> List (Html Msg)
viewUpdates updates =
    let
        count =
            List.length updates

        -- |> Debug.log "count"
        root =
            sqrt (toFloat count)
                |> ceiling

        -- |> Debug.log "ROOT"
        -- |> Debug.log "root"
        width =
            root
                |> toFloat
                |> (/) 1
                |> (*) 100
                |> floor

        -- |> Debug.log "WIDTH"
        widthStyle =
            "calc(" ++ String.fromInt width ++ "% - 25px)"
    in
    [ Html.Keyed.node "div"
        []
        (List.map
            (\upd ->
                ( "podcast-" ++ String.fromInt upd.id
                , img
                    [ Html.Attributes.src upd.imageUrl
                    , Html.Attributes.style "border" "2px solid white"
                    , Html.Attributes.style "width" widthStyle
                    , Html.Attributes.class "pop-img"
                    , Html.Events.onClick <|
                        ShowPopup <|
                            Content <|
                                div [ Html.Attributes.class "podcast-details" ]
                                    [ img
                                        [ Html.Attributes.src upd.imageUrl
                                        , Html.Attributes.class "main-img"
                                        , Html.Events.onClick <|
                                            HidePopup
                                        ]
                                        []
                                    , h2 [] [ img [ Html.Attributes.src <| "https://www.countryflags.io/" ++ upd.country ++ "/shiny/24.png" ] [], text upd.title ]
                                    , text upd.description
                                    ]
                    ]
                    []
                )
            )
            updates
        )
    ]


noCmd model =
    ( model, Cmd.none )


spinner =
    div [ class "lds-ripple" ]
        [ div []
            []
        , div []
            []
        ]
